import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators } from '@nkr/store/index';
import { IXmTracking } from '@nkr/models/index';
import { TableWrapper, GridWrapper } from './styles';
import { Button, FormControl } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { AdminActionCenterActionCreators } from '@nkr/store/index';
import { CellClickedEvent, ColDef, FirstDataRenderedEvent, GridApi, GridReadyEvent, GridSizeChangedEvent, IHeaderParams, RowDataChangedEvent } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { AgGridReact } from 'ag-grid-react';
interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getXmResultsDue: (date?: string) => Promise<any>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: IXmTracking[],
    startDate: string,
    centerId: number,
    gridApi: GridApi
}

class CryoXmResultsRecordedLateReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        startDate: moment().date(1).format('YYYY-MM-DD'),
        centerId: 0,
        gridApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });

        e.api.sizeColumnsToFit();
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
    };



    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Loading data, one moment please...").then(() => {
            this.props.getXmResultsDue(this.state.startDate).then(response => {
                this.setState({
                    list: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }

    getCenterList = () => {
        let list = this.state.list.map(x => {
            return { id: x.recipientCenterId, alias: x.recipientCenterAlias };
        });

        let centers = _.uniqBy(list, item => item.id);

        return _.sortBy(centers, item => item.alias);
    }

    getFilteredList = () => {
        return this.state.list.filter(x => {
            let centerFilter = this.state.centerId > 0 ? x.recipientCenterId == this.state.centerId : true;

            return centerFilter;
        });
    }

    getSwapNumber = (item: IXmTracking) => {
        if (item.chainNumber != null && item.clusterNumber != null && item.positionNumber != null) {
            return item.chainNumber + '/' + item.clusterNumber + '/' + item.positionNumber;
        } else {
            return '';
        }
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            startDate: e.currentTarget.value
        }, () => {
            this.getData();
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        let currentMonth = moment(this.state.startDate)
        let monthYear = currentMonth.format('MM-YYYY')

        let data = this.state.list;

        let csvContent = 'data:text/csv;charset=utf-8,'
            + 'Type,Chain,Cluster,Position,Donor Center,Donor Alias,Recipient Center,Recipient Alias,Status,Date Requested,Date Shipped Out,Date Shipped Back,Date Received,Date Results Due,Date Results Recorded\n'
            + data.map(e =>
                e.xmTypeDescription
                + ',' + (e.chainNumber != null ? e.chainNumber : '')
                + ',' + (e.clusterNumber != null ? e.clusterNumber : '')
                + ',' + (e.positionNumber != null ? e.positionNumber : '')
                + ',' + e.donorCenterAlias + ',' + e.donorAlias + ',' + e.recipientCenterAlias + ',' + e.recipientAlias
                + ',' + e.xmStatusDescription + ',' + e.requestedDate + ',' + e.shipOutDate
                + ',' + e.shipBackDate + ',' + e.receivedDate + ',' + e.dateResultsDue + ',' + e.receivedBackDate + ',' + e.resultsRecordedDate
            ).join('\n');

        let encodedUri = encodeURI(csvContent);

        let link = document.createElement('a');

        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'cryo-xm--results-recorded-late_' + monthYear + '.csv');

        document.body.appendChild(link);

        link.click();
    }




    render = () => {
        const centerList = this.getCenterList();
        const filteredList = this.getFilteredList();
        const dateList = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month').map(d => d.date(1));

        // Define the column definitions
        const cols: ColDef[] = [
            {
                colId: 'id',
                field: 'id',
                headerName: 'Order #',
                width: 100,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Order #</SortableHeaderComponent>
            },
            {
                colId: 'xmTypeDescription',
                field: 'xmTypeDescription',
                headerName: 'Type',
                width: 100,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Type</SortableHeaderComponent>
            },
            {
                colId: 'swapNumber',
                field: 'swapNumber',
                headerName: 'Swap',
                width: 90,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Swap</SortableHeaderComponent>
            },
            {
                colId: 'donorCenterAlias',
                field: 'donorCenterAlias',
                headerName: 'Donor Center',
                width: 140,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Donor Center</SortableHeaderComponent>
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                width: 120,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Donor Alias</SortableHeaderComponent>
            },
            {
                colId: 'recipientCenterAlias',
                field: 'recipientCenterAlias',
                headerName: 'Recipient Center',
                width: 140,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Recipient Center</SortableHeaderComponent>
            },
            {
                colId: 'recipientAlias',
                field: 'recipientAlias',
                headerName: 'Recipient Alias',
                width: 120,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Recipient Alias</SortableHeaderComponent>
            },
            {
                colId: 'xmStatusDescription',
                field: 'xmStatusDescription',
                headerName: 'Status',
                width: 120,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Status</SortableHeaderComponent>
            },
            {
                colId: 'requestedDate',
                field: 'requestedDate',
                headerName: 'Date Requested',
                width: 140,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Requested</SortableHeaderComponent>
            },
            {
                colId: 'shipOutDate',
                field: 'shipOutDate',
                headerName: 'Date Shipped Out',
                width: 150,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Shipped Out</SortableHeaderComponent>
            },
            {
                colId: 'receivedDate',
                field: 'receivedDate',
                headerName: 'Date Received',
                width: 140,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Received</SortableHeaderComponent>
            },
            {
                colId: 'shipBackDate',
                field: 'shipBackDate',
                headerName: 'Date Shipped Back',
                width: 160,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Shipped Back</SortableHeaderComponent>
            },
            {
                colId: 'receivedBackDate',
                field: 'receivedBackDate',
                headerName: 'Date Received Back',
                width: 170,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Received Back</SortableHeaderComponent>
            },
            {
                colId: 'dateResultsDue',
                field: 'dateResultsDue',
                headerName: 'Date Results Due',
                width: 150,
                sortable: true,
                headerComponentFramework: (params: IHeaderParams) =>
                    <SortableHeaderComponent {...params}>Date Results Due</SortableHeaderComponent>
            }
        ];


        return (
            <div style={{ minHeight: 500, paddingLeft: this.props.isCenterLogin ? 20 : 0, paddingRight: this.props.isCenterLogin ? 20 : 0 }}>

                {this.props.isCenterLogin == false && (
                    <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Final XM Results Recorded Late (&gt; 3 Business Days)</div>
                    </div>
                )}


                <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Center + Month filters side by side */}
                    {!this.props.isCenterLogin && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ whiteSpace: 'nowrap' }}>Filter by Center:</span>
                            <FormControl
                                componentClass='select'
                                value={this.state.centerId}
                                onChange={this.handleCenterChange}
                            >
                                <option value={0}>- All Centers -</option>
                                {centerList.map(center =>
                                    <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                )}
                            </FormControl>

                            <span style={{ whiteSpace: 'nowrap' }}>Select Month:</span>
                            <FormControl
                                componentClass='select'
                                value={this.state.startDate}
                                onChange={this.handleDateChange}
                            >
                                {dateList.map(d =>
                                    <option key={d.format('YYYY-MM-DD')} value={d.format('YYYY-MM-DD')}>
                                        {d.format('MMMM YYYY')}
                                    </option>
                                )}
                            </FormControl>
                        </div>
                    )}

                    {/* Export button on the right */}
                    <div>
                        <Button onClick={this.handleExport}>Export to CSV</Button>
                    </div>
                </div>

                <GridWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        columnDefs={cols}
                        rowData={filteredList}  // using your existing filtered list
                        headerHeight={40}
                        rowHeight={30}
                        suppressCellSelection={true}
                        suppressContextMenu={true}
                        overlayNoRowsTemplate={`No Final XM results recorded late for ${moment(this.state.startDate).format('MMMM YYYY')}...`}
                        overlayLoadingTemplate="Loading XM results..."
                        getRowNodeId={(data: any) => data.id.toString()}
                        onGridReady={this.onGridReady}
                        onFirstDataRendered={this.onFirstDataRendered}
                        onBodyScroll={null}
                        onGridSizeChanged={this.onGridSizeChanged}
                        onRowDataChanged={this.onRowDataChanged}
                        columnHoverHighlight={true}
                    />
                </GridWrapper>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        // reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getXmResultsDue: (date) => {
            return dispatch(AdminActionCenterActionCreators.getXmResultsDue(date));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CryoXmResultsRecordedLateReport);